<picture>
    <source media="(min-width: 1200px)" [attr.defaultImage]="defaultImage" [attr.lazyLoad]="imageLg">
    <source media="(min-width: 992px)" [attr.defaultImage]="defaultImage" [attr.lazyLoad]="imageMd">
    <source media="(min-width: 480px)" [attr.defaultImage]="defaultImage" [attr.lazyLoad]="imageXs">
    <img [defaultImage]="defaultImage" [lazyLoad]="imageJpeg" class="box-model__photo-img" (error)="setDefaultImg($event)" [alt]="alt" />
</picture>
